import React from "react"
import { useTranslation } from "react-i18next"

import i18n from "config/i18n"
import { isTermsPDF } from "helpers/features"
import { useAppSelector } from "redux/hooks"
import { selectSettingsById } from "redux/features/settings/settingsSlice"
import { Content, Sections, Download } from "pages/static/elements"
import Title from "components/ui/Title"
import { INSTANCE } from "config"
import {
  // NOTE: {{INSTANCE}}_{{LANG}}_Content
  FRESHFINANCE_EE_EN_Content,
  FRESHFINANCE_EE_ET_Content,
  FRESHFINANCE_EE_RU_Content,
} from "pages/static/terms/freshfinance_ee"
import {
  FRESHFINANCE_LT_EN_Content,
  FRESHFINANCE_LT_LT_Content,
  FRESHFINANCE_LT_RU_Content,
} from "pages/static/terms/freshfinance_lt"
import {
  EE_PUNKFINANCE_EN_Content,
  EE_PUNKFINANCE_ET_Content,
  EE_PUNKFINANCE_RU_Content,
} from "pages/static/terms/ee_punkfinance"
import { SettingsType } from "types"

const TermsPage = () => {
  const { t } = useTranslation()

  const settings = useAppSelector(
    (state) => selectSettingsById(state, 0) as SettingsType,
  )

  const renderSections = () => {
    switch (INSTANCE) {
      case "freshfinance_ee":
        switch (i18n.language) {
          case "en":
            return <FRESHFINANCE_EE_EN_Content />
          case "ru":
            return <FRESHFINANCE_EE_RU_Content />
          default:
            return <FRESHFINANCE_EE_ET_Content />
        }

      case "freshfinance_lt":
        switch (i18n.language) {
          case "en":
            return <FRESHFINANCE_LT_EN_Content />
          case "ru":
            return <FRESHFINANCE_LT_RU_Content />
          default:
            return <FRESHFINANCE_LT_LT_Content />
        }

      case "ee_punkfinance":
        switch (i18n.language) {
          case "en":
            return <EE_PUNKFINANCE_EN_Content />
          case "ru":
            return <EE_PUNKFINANCE_RU_Content />
          default:
            return <EE_PUNKFINANCE_ET_Content />
        }

      default:
        return <FRESHFINANCE_EE_ET_Content />
    }
  }

  return (
    <Content data-testid="terms-page">
      <Title>{t("pages.terms.title")}</Title>
      <Sections>{renderSections()}</Sections>
      {isTermsPDF(settings?.features) && (
        <Download>
          <a href="/terms.pdf" target="_blank">
            {t("common.download")}
          </a>
        </Download>
      )}
    </Content>
  )
}

export default TermsPage
